import store from '@/store'
import { getInstance } from './sessionAuth'

export const authGuard = (to, from, next) => {
  const authInstance = getInstance()

  const proceed = () => {
    if (store.getters['user/isLoggedIn']) {
      if (to.meta && to.meta.needsPermission) {
        // IMPORTANT: return here so the next() below does NOT also fire
        return store.dispatch('USER_HAS_PERMISSION', to.meta.needsPermission)
          .then(hasPermission => {
            if (!hasPermission) {
              const homePath = store.state.user.userInfo.homePath
              // Prevent infinite redirect loop: if homePath IS the route we don't have
              // permission for, redirect to a safe fallback instead of looping forever
              if (homePath === to.name) {
                console.error('[authGuard] Permission denied for homePath route:', homePath, '— redirecting to /no-access')
                return next({ path: '/no-access' })
              }
              return next({ name: homePath })
            } else {
              return next()
            }
          })
      }
      // No permission check needed — allow through
      return next()
    }

    // Vuex says not logged in — but session might still be valid (e.g. after deploy
    // clears localStorage while connect.sid cookie persists). Check sessionAuth.
    if (authInstance && authInstance.isAuthenticated && authInstance.user) {
      return store.dispatch('user/setUser', authInstance.user).then(() => {
        return next()
      }).catch(() => {
        return next({ path: '/login' })
      })
    }

    // Not logged in — redirect to login page
    return next({ path: '/login' })
  }

  // If sessionAuth is still loading (async /api/auth/me call), wait for it
  if (authInstance && authInstance.loading) {
    const unwatch = authInstance.$watch('loading', (loading) => {
      if (!loading) {
        unwatch()
        proceed()
      }
    })
    // Safety timeout: don't wait forever
    setTimeout(() => {
      try { unwatch() } catch (e) { /* already unwatched */ }
      proceed()
    }, 3000)
    return
  }

  return proceed()
}
